import { useFilterSearchParams } from "@/utils/hooksUtils";
import { Card } from "antd";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../../agent/api";
import { DEFAULT_FILTER_COMMISSIONS_OUTPUTS_QUERY_PARAMS } from "../api";
import { CommissionsOutputsFilterForm } from "../components/forms/CommissionsOutputsFilterForm";
import { CommissionsOutputsTable } from "../components/tables/CommissionsOutputsTable";
import { CommissionsOutputFilterPageRequest } from "../types";

export const CommissionsOutputsContainer = () => {
  const searchParams = useFilterSearchParams<CommissionsOutputFilterPageRequest>({
    params: ["report", "batchKeyword", "categories", ...COMMON_AGENT_FILTER_SEARCH_PARAMS, "includeUnprocessed"],
    defaultQueryParamsObject: DEFAULT_FILTER_COMMISSIONS_OUTPUTS_QUERY_PARAMS,
  });

  return (
    <>
      <CommissionsOutputsFilterForm searchParams={searchParams} />

      <Card className="card-box">
        <CommissionsOutputsTable searchParams={searchParams} />
      </Card>
    </>
  );
};
